import { BaseRouteService } from "core/services";

class ConfirmingReportRouteService extends BaseRouteService {
	constructor() {
		super("confirming-reports");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fieldst}`, filter);
	}	
	
	uploadReport(resource) {
		return super.create(`${this.base}/upload-report`, resource);
	}
}

export default ConfirmingReportRouteService;